import { uiText, useUiLanguage } from '../../../utils/uiTranslation';
import React from 'react';

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const getRetentionCellStyle = (value) => {
  const bounded = clamp((Number(value || 0)) / 100, 0, 1);
  const hue = 6 + (bounded * 114);
  const saturation = 70;
  const lightness = 22 + (bounded * 34);
  return {
    background: `hsl(${hue.toFixed(1)} ${saturation}% ${lightness.toFixed(1)}%)`,
    color: bounded > 0.34 ? 'rgba(var(--app-ink-rgb, 255, 255, 255), 0.98)' : 'rgba(var(--app-ink-rgb, 255, 255, 255), 0.92)'
  };
};

const RetentionTimelineVisual = ({ model }) => {
  useUiLanguage();
  const dataset = model.dataset;
  const rows = dataset?.rows || [];
  const columns = dataset?.columns || [];
  const cells = dataset?.cells || [];

  if (!rows.length || !columns.length) return null;

  const cellMap = cells.reduce((accumulator, cell) => {
    accumulator[`${cell.rowId}:${cell.columnId}`] = cell;
    return accumulator;
  }, {});

  if ((model.size || 'medium') === 'compact') {
    return (
      <div className="analytics-visual analytics-visual-scatter-list">
        {rows.map((row) => {
          const latestCell = [...columns]
            .reverse()
            .map((column) => cellMap[`${row.id}:${column.id}`])
            .find((cell) => cell && !cell.pending);
          return (
            <div key={row.id} className="analytics-visual-scatter-list-row">
              <div className="analytics-visual-scatter-list-name">
                <span className="analytics-visual-label">{uiText(row.label)}</span>
              </div>
              <div className="analytics-visual-scatter-list-metrics">
                <strong>{latestCell ? `${Number(latestCell.value).toFixed(0)}%` : uiText("Pending")}</strong>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  const gridTemplateColumns = `1.25fr repeat(${columns.length}, minmax(0, 0.82fr))`;

  return (
    <div className="analytics-visual analytics-visual-retention-grid">
      <div className="analytics-visual-retention-legend">
        <span className="analytics-visual-legend-item"><span className="analytics-visual-legend-swatch danger" />{uiText("Low retention")}</span>
        <span className="analytics-visual-legend-item"><span className="analytics-visual-legend-swatch warning" />{uiText("Moderate retention")}</span>
        <span className="analytics-visual-legend-item"><span className="analytics-visual-legend-swatch success" />{uiText("High retention")}</span>
        <span className="analytics-visual-legend-item"><span className="analytics-visual-retention-pending-dot" />{uiText("Pending milestone")}</span>
      </div>

      <div className="analytics-visual-heatmap-head" style={{ gridTemplateColumns }}>
        <span className="analytics-visual-heatmap-corner" />
        {columns.map((column) => (
          <span key={column.id} className="analytics-visual-heat-column-label">{uiText(column.label)}</span>
        ))}
      </div>

      {rows.map((row) => (
        <div key={row.id} className="analytics-visual-heatmap-row" style={{ gridTemplateColumns }}>
          <span className="analytics-visual-heat-row-label">{uiText(row.label)}</span>
          {columns.map((column) => {
            const cell = cellMap[`${row.id}:${column.id}`];
            if (!cell) return <span key={column.id} className="analytics-visual-retention-cell pending">{uiText("Pending")}</span>;
            if (cell.pending) {
              return (
                <span key={column.id} className="analytics-visual-retention-cell pending">
                  {cell.label || uiText("Pending")}
                </span>
              );
            }
            return (
              <span
                key={column.id}
                className="analytics-visual-retention-cell"
                style={getRetentionCellStyle(cell.value)}
              >
                {`${Number(cell.value).toFixed(0)}%`}
              </span>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default RetentionTimelineVisual;
